import React from "react";
import { Player } from "@lottiefiles/react-lottie-player";
import Lottie from "react-lottie-player";
import Stars from "./stars.json";
import MessagingLock from "./message and lock.json";
import shieldLock from "./shield lock.json";
import { Link } from "react-router-dom";
const Secure = () => {
  return (
    <div className="secure pt-5">
      <div className="container pt-5">
        <div className="messaging">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-3">
              {/* <div className="inner-mess-bg">
                    <div className="w-50">
                      <h3 className="mb-3">Secure Messaging</h3>
                      <ProgressBar now={60} />
                      <div className="mess-box mt-4">
                        That’s very nice place! you guys made a very good
                        decision. Can’t wait to go on vacation!
                      </div>
                      <img
                        className="mt-3"
                        src="/assets/images/typing.png"
                        alt="typing"
                      />
                      <img
                        className="profile"
                        src="/assets/images/profile.png"
                        alt="profile"
                      />
                    </div>
                  </div> */}
              <img
                className="w-100"
                src="/assets/images/messaging-frame.png"
                alt="messaging"
                data-aos="fade-up"
                data-aos-duration="1000"
              />
            </div>
            <div
              className="col-lg-6 mb-3 p-3 p-md-5"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              {/* <img
                    className="mb-3"
                    src="/assets/images/Messaging.png"
                    style={{ width: "80px" }}
                    alt="Messaging"
                  /> */}
              <Lottie
                loop
                play
                animationData={MessagingLock}
                style={{ width: "150px", height: "150px" }}
              />
              <h4 className="mb-3">Decentralized Messaging:</h4>
              <h2 className="mb-3">
                Your data, your <br /> control.
              </h2>
              <p>
                Nimbus Chat leverages the Matrix protocol for secure, open, and
                private communication.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="messaging powered" style={{ marginBottom: "0px" }}>
          <div className="row align-items-center">
            <div
              className="col-lg-6 mb-3  p-3 p-md-5"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              {/* <img
                    className="mb-3"
                    style={{ width: "80px" }}
                    src="/assets/images/stars-01.png"
                    alt="Messaging"
                  /> */}
              <Lottie
                loop
                play
                animationData={Stars}
                style={{ width: "150px", height: "150px" }}
              />
              <h4 className="mb-3">AI-Powered Enhancements:</h4>
              <h2 className="mb-3">
                AI-Powered <br /> Enhancements
              </h2>
              <p>
                Nimbus Chat leverages the Matrix protocol for secure, open, and
                private communication.
              </p>
            </div>
            <div
              className="col-lg-6 mb-3"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              {/* <div className="inner-mess-bg">
                    <div className="w-50">
                      <button className="bg-btn mb-3">AI POWERED</button>
                      <h3 className="mb-3">Secure Messaging</h3>
                      <ProgressBar now={60} />
                      <div className="mess-box mt-4">
                        That’s very nice place! you guys made a very good
                        decision. Can’t wait to go on vacation!
                      </div>
                      <img
                        className="mt-3 w-100"
                        src="/assets/images/File Upload.png"
                        alt="File Upload"
                      />
                      <div className="d-flex align-items-center justify-content-between">
                        <button
                          className="bg-white-btn px-2 p-1"
                          style={{
                            textAlign: "center",
                            color: "#344054",
                            fontSize: 9,
                            fontWeight: "600",
                            wordWrap: "break-word",
                          }}
                        >
                          Change tone
                        </button>
                        <button
                          className="bg-white-btn px-2 p-1"
                          style={{
                            textAlign: "center",
                            color: "#344054",
                            fontSize: 9,
                            fontWeight: "600",
                            wordWrap: "break-word",
                          }}
                        >
                          Rephrase
                        </button>
                        <button
                          className="bg-white-btn px-2 p-1"
                          style={{
                            textAlign: "center",
                            color: "#344054",
                            fontSize: 9,
                            fontWeight: "600",
                            wordWrap: "break-word",
                          }}
                        >
                          Auto correct
                        </button>
                      </div>
                    </div>
                  </div> */}
              <img
                className="w-100"
                src="/assets/images/enchance-frame.png"
                style={{ width: "80px" }}
                alt="privacy"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="last" style={{ padding: "100px 0px" }}>
          <div
            className="messaging powered "
            style={{ position: "relative", zIndex: "10" }}
          >
            <div className="row align-items-center">
              <div
                className="col-lg-6 mb-3"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                {/* <div className="inner-mess-bg">
                    <div className="w-50">
                      <button className="bg-btn mb-3">AI POWERED</button>
                      <h3 className="mb-3">Secure Messaging</h3>
                      <ProgressBar now={60} />
                      <div className="mess-box mt-4">
                        That’s very nice place! you guys made a very good
                        decision. Can’t wait to go on vacation!
                      </div>
                      <img
                        className="mt-3 w-100"
                        src="/assets/images/File Upload.png"
                        alt="File Upload"
                      />
                      <div className="d-flex align-items-center justify-content-between">
                        <button
                          className="bg-white-btn px-2 p-1"
                          style={{
                            textAlign: "center",
                            color: "#344054",
                            fontSize: 9,
                            fontWeight: "600",
                            wordWrap: "break-word",
                          }}
                        >
                          Change tone
                        </button>
                        <button
                          className="bg-white-btn px-2 p-1"
                          style={{
                            textAlign: "center",
                            color: "#344054",
                            fontSize: 9,
                            fontWeight: "600",
                            wordWrap: "break-word",
                          }}
                        >
                          Rephrase
                        </button>
                        <button
                          className="bg-white-btn px-2 p-1"
                          style={{
                            textAlign: "center",
                            color: "#344054",
                            fontSize: 9,
                            fontWeight: "600",
                            wordWrap: "break-word",
                          }}
                        >
                          Auto correct
                        </button>
                      </div>
                    </div>
                  </div> */}
                <img
                  className="w-100"
                  src="/assets/images/chat-frame.png"
                  alt="privacy"
                />
              </div>
              <div
                className="col-lg-6 mb-3  p-3 p-md-5"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                {/* <img
                      className="mb-3"
                      src="/assets/images/privacy.png"
                      style={{ width: "80px" }}
                      alt="privacy"
                    /> */}
                <Lottie
                  loop
                  play
                  animationData={shieldLock}
                  style={{ width: "150px", height: "150px" }}
                />
                <h4 className="mb-3">Privacy-First</h4>
                <h2 className="mb-3">
                  Uncompromising <br /> Privacy
                </h2>
                <p>
                  End to end encryption by default <br />
                  Your Conversation stay yours- AI processing happens locally
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="d-flex align-items-center justify-content-center justify-content-md-start ">
          {/* <Player
            autoplay
            style={{ width: "400px", height: "400px" }}
            loop
            src="/assets/frog looks left right.json"
          /> */}
        </div>
        <div className="internal-part mb-5">
          <h4>How Nimbus AI Works</h4>
        </div>
      </div>
      <div className="new-sec" style={{ position: "relative" }}>
        <img
          className="topcloud"
          src="/assets/images/left-curve.png"
          alt="onecloud"
        />
        <div className="container">
          <div className="messaging powered mb-5">
            <div className="row align-items-center">
              <div
                className="col-lg-12"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <h3 className="mb-3">
                  The Technology Behind Nimbus: Privacy-First AI Messaging
                </h3>
                <p>
                  Nimbus combines the security of Matrix protocol with powerful
                  local AI processing to deliver intelligent messaging that
                  keeps your data private. Every message, every AI suggestion,
                  and every translation happens right on your device.
                </p>
              </div>
            </div>
          </div>

          <div className="messaging powered mb-5">
            <div className="row align-items-center">
              <div
                className="col-lg-12"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <img
                  className="w-100 d-none d-lg-block  "
                  src="/assets/images/Encryption-frame.png"
                  alt="empty"
                />
                <img
                  className="w-100 d-block d-lg-none  "
                  src="/assets/images/mobile-encryption.png"
                  alt="empty"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div
              className="col-lg-4 h-100"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <div
                className="messaging powered card-cus h-100  mb-5 mb-lg-auto"
                style={{
                  background:
                    " linear-gradient(103deg, rgba(108.96, 108.96, 108.96, 0.45) 0%, rgba(54.37, 54.37, 54.37, 0.50) 62%, rgba(128.30, 128.30, 128.30, 0.50) 100%)",
                }}
              >
                <h3 className="mb-3">
                  Local AI <br /> Processing
                </h3>
                <p>
                  Your conversations deserve privacy. That's why all AI features
                  in Nimbus - from smart replies to translations - run directly
                  on your device. No data leaves your control, ensuring your
                  privacy while delivering intelligent messaging features.
                </p>
              </div>
            </div>
            <div
              className="col-lg-4 h-100"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <div
                className="messaging powered card-cus  h-100  mb-5 mb-lg-auto"
                style={{
                  background:
                    " linear-gradient(103deg, rgba(108.96, 108.96, 108.96, 0.45) 0%, rgba(54.37, 54.37, 54.37, 0.50) 62%, rgba(128.30, 128.30, 128.30, 0.50) 100%)",
                }}
              >
                <h3 className="mb-3">
                  Matrix <br /> Integration
                </h3>
                <p>
                  Built on the Matrix protocol, Nimbus ensures end-to-end
                  encrypted communication across the decentralized Matrix
                  network. Your messages are secure from device to device, with
                  no central server having access to your unencrypted data.
                </p>
              </div>
            </div>
            <div
              className="col-lg-4 h-100"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <div
                className="messaging powered h-100 card-cus   mb-5 mb-lg-auto"
                style={{
                  background:
                    " linear-gradient(103deg, rgba(108.96, 108.96, 108.96, 0.45) 0%, rgba(54.37, 54.37, 54.37, 0.50) 62%, rgba(128.30, 128.30, 128.30, 0.50) 100%)",
                }}
              >
                <h3 className="mb-3">
                  Simple Experience, <br /> Complex Security
                </h3>
                <p>
                  While the technology behind Nimbus is sophisticated, the
                  experience is seamless. Send messages, get intelligent
                  suggestions, and communicate across languages - all with the
                  confidence that your privacy is protected at every step.
                </p>
              </div>
            </div>
          </div>
        </div>
        <img
          className="onecloud"
          src="/assets/images/onecloud.png"
          alt="onecloud"
        />
      </div>

      <div className="container  ">
        <div
          className="internal-part mb-5"
          style={{ marginTop: "100px !important" }}
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          <div className="text-center  updown">
            <Player
              autoplay
              // className="nim-2"
              style={{ width: "300px", height: "300px" }}
              loop
              src="/assets/jet pack json.json"
            />
          </div>
          <h4>
            Be Part of the Future <br /> of Messaging
          </h4>
          <p>
            Join the Nimbus Chat beta program and experience <br />{" "}
            decentralized, AI-enhanced messaging before anyone <br /> else.
          </p>
        </div>
      </div>
      <div className="container">
        <div className="messaging powered">
          <div className="row align-items-center">
            <div
              className="col-lg-12"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <img
                className="w-100 mb-3"
                src="/assets/images/Join.png"
                alt="empty"
              />
              <h5 className="mb-3">Nimbus Chat beta program</h5>
              <h2 className="mb-3 text-center">Join Beta</h2>

              <div className="text-center mt-3">
                <Link to={"/register"}>
                  <button className="bg-btn">
                    Join Now{" "}
                    <img src="/assets/images/rightarrow.svg" alt="rightarrow" />
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style={{ position: "relative" }}>
        <Player
          autoplay
          loop
          style={{ width: "850px", height: "850px" }}
          src="/assets/blue hoodie idle.json"
          className="slide-robo"
        />
        <img
          className="nim-1"
          src="/assets/images/Ai Robot.png"
          alt="Ai Robot"
        />
        <img
          className="w-100"
          src="/assets/images/NIMBUSTEXT.png"
          alt="NIMBUSTEXT"
        />
        {/* <img
          className="nim-2"
          src="/assets/images/hero-robot.png"
          alt="Ai Robot"
        /> */}
        <Player
          autoplay
          className="nim-2"
          style={{ width: "200px", height: "200px" }}
          loop
          src="/assets/jet pack json.json"
        />
      </div>
    </div>
  );
};

export default Secure;
